module.exports = __webpack_public_path__ + "media/images/Cup-Empty-Zoomed-200-e3f2bc332df5e8fcfcaa85b320caf4d0.png";